( function( $ ) {
	'use strict';

	var searchTrigger  		= $( '.search-box__trigger' ),
		searchBox 			= $( '.search-box' ),
		searchActiveClass  	= 'search-box--active',
		searchInput 		= $( '.search-box__input' ),
		searchClose 		= $( '.search-box__close' );

	searchTrigger.on( 'click', function() {
		searchBox.toggleClass( searchActiveClass );
		searchInput.focus();
	} );

	searchClose.on( 'click', function() {
		$( this ).parent().parent().parent().removeClass( searchActiveClass );
		searchInput.focusout();
	} );

	// close search-box with click off
	$( document ).mouseup( function ( e ) {
		if ( !searchBox.is( e.target )
			&& 0 === searchBox.has( e.target ).length )
		{
			searchBox.removeClass( searchActiveClass );
			searchInput.focusout();
		}
	} );

} )( jQuery );
